export enum EValueChangesStatus {
    Increased = "Increased",
    Decreased = "Decreased",
 
  }
  
  